import { useState } from 'react';
import { Button, ButtonTheme, GenericAlertPopup } from '@apply/components';
import { AuthorizedDrawUserDto, ApplyApi } from '@apply/api/src/api/ApplyApi';
import { applicationInsights } from '../../../../../../../../../ApplicationInsights';

export interface ResendInviteButtonProps {
    user: AuthorizedDrawUserDto;
    onClose?: () => void;
}

export const ResendInviteButton: React.FC<ResendInviteButtonProps> = ({ user, onClose }) => {
    const [resending, setResending] = useState<boolean>(false);

    const handleResendInvite = async () => {
        onClose?.();
        if (!user.email) {
            GenericAlertPopup({
                title: 'Error',
                children: 'Cannot resend invite: user email not found.',
                width: '350px',
            });
            return;
        }

        setResending(true);

        try {
            const applyApi = new ApplyApi(applicationInsights);
            const response = await applyApi.resendDrawAuthorizedUserInvite(user.userId);

            if (response.statusCode === 200) {
                GenericAlertPopup({
                    title: 'Success',
                    children: 'Invitation resent successfully!',
                    width: '350px',
                });
            } else {
                const errorMsg = response.errors?.length > 0 ? response.errors.join(', ') : 'Failed to resend invitation';
                throw new Error(errorMsg);
            }
        } catch (error) {
            console.error('Failed to resend invitation:', error);
            const errorMessage = error instanceof Error ? error.message : 'Failed to resend invitation. Please try again.';
            GenericAlertPopup({
                title: 'Error',
                children: errorMessage,
                width: '350px',
            });
        } finally {
            setResending(false);
        }
    };

    return (
        <Button
            id={`gcResendInviteButton_${user.userId}`}
            theme={ButtonTheme.LinkBlue}
            height='15px'
            handleClick={handleResendInvite}
            disabled={resending}
        >
            {resending ? 'Sending...' : 'Re-send Invite'}
        </Button>
    );
};
